import styles from './Separator.module.css';

function Separator({ width = '60px', height = '2px', align = 'center' }) {
  const margin = align === 'center' ? '0 auto' : align === 'right' ? '0 0 0 auto' : '0';

  return (
    <div className={styles.separator} style={{ width, height, margin }} />
  );
}

export default Separator;
